module.exports = __webpack_public_path__ + "img/handraw_transporteur_marron.b13611d8.svg";